/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MonsterForge from './MonsterForge';
import PrivacyNotice from './auth/PrivacyNotice';
import TermsAndConditions from './auth/TermsAndConditions';
import Account from './auth/Account';
import SubscriptionSuccess from './auth/SubscriptionSuccess';
import { User } from 'firebase/auth';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/monsterforge" element={<MonsterForge/>} />
        <Route path="/monsterforge/account" element={<Account onClose={() => {window.location.href = '/monsterforge'}} onUserChanged={(newUser: User | null) => {}}/>} />
        <Route path="/monsterforge/subscription-success" element={<SubscriptionSuccess onClose={() => {window.location.href = '/monsterforge'}}/>} />
        <Route path="/monsterforge/dataPrivacy" element={<PrivacyNotice onClose={() => {window.location.href = '/monsterforge'}} />} />
        <Route path="/monsterforge/terms" element={<TermsAndConditions onClose={() => {window.location.href = '/monsterforge'}} />} />
      </Routes>
    </Router>
  );
};

export default App;